require(210);
var entryUnbind = require(141);

module.exports = entryUnbind('Array', 'find');
